import MDBox from "components/MDBox";
import UiButton from "components/base/UiButton";
import UiTypography from "components/base/UiTypography";

type MeasurementsSidebarHeaderProps = {
  onHide: () => void;
};

export default function MeasurementsSidebarHeader({ onHide }: MeasurementsSidebarHeaderProps) {
  return (
    <MDBox
      px="20px"
      py="16px"
      borderBottom="1px solid #E5E7EB"
      display="flex"
      justifyContent="space-between"
      alignItems="flex-start"
      gap="12px"
    >
      <UiTypography uiVariant="heading-sm">Assign Measurements</UiTypography>
      <UiButton uiVariant="outlined" onClick={onHide}>
        Hide
      </UiButton>
    </MDBox>
  );
}
